define("media/controllers/application", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/object/computed", "@ember/service", "@ember/utils", "@glimmer/tracking", "ember-concurrency", "nprogress", "tracked-built-ins", "later/utils/constants", "later/utils/format-query", "shared/utils/delete-media-item"], function (_exports, _asyncArrowRuntime, _controller, _object, _computed, _service, _utils, _tracking, _emberConcurrency, _nprogress, _trackedBuiltIns, _constants, _formatQuery, _deleteMediaItem) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _removeMovedMediaItems, _deselectAndFilter, _clearMediaFilters, _filteredQuery;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"@glimmer/tracking",0,"ember-concurrency",0,"nprogress",0,"tracked-built-ins",0,"later/utils/constants",0,"later/utils/format-query",0,"shared/utils/delete-media-item"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let ApplicationController = _exports.default = (_dec = (0, _computed.readOnly)('mediaItemQuery.queryListQuery'), _dec2 = (0, _computed.readOnly)('mediaItemQuery.queryListStartQuery'), _dec3 = (0, _computed.sort)('visibleMediaItems', 'mediaSortDefinition'), _dec4 = (0, _object.computed)('mediaItemQuery.queries.@each.isLoading', 'queryListStartQuery', 'queryListQuery'), _dec5 = (0, _object.computed)('mediaItemQuery.queries.@each.isLoadingMore', 'queryListQuery', 'queryListStartQuery'), _dec6 = (0, _object.computed)('queryListQuery'), _dec7 = (0, _object.computed)('allMediaItems.@each.labels', 'queryListQuery'), (_class = (_removeMovedMediaItems = /*#__PURE__*/new WeakSet(), _deselectAndFilter = /*#__PURE__*/new WeakSet(), _clearMediaFilters = /*#__PURE__*/new WeakSet(), _filteredQuery = /*#__PURE__*/new WeakSet(), class ApplicationController extends _controller.default {
    constructor(args) {
      super(args);
      _classPrivateMethodInitSpec(this, _filteredQuery);
      _classPrivateMethodInitSpec(this, _clearMediaFilters);
      _classPrivateMethodInitSpec(this, _deselectAndFilter);
      _classPrivateMethodInitSpec(this, _removeMovedMediaItems);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "mediaItemQuery", _descriptor5, this);
      _initializerDefineProperty(this, "mediaLabels", _descriptor6, this);
      _initializerDefineProperty(this, "mediaNavigation", _descriptor7, this);
      _initializerDefineProperty(this, "queryPersistence", _descriptor8, this);
      _initializerDefineProperty(this, "router", _descriptor9, this);
      _initializerDefineProperty(this, "segment", _descriptor10, this);
      _initializerDefineProperty(this, "starredMedia", _descriptor11, this);
      _initializerDefineProperty(this, "queryListQuery", _descriptor12, this);
      _initializerDefineProperty(this, "queryListStartQuery", _descriptor13, this);
      _initializerDefineProperty(this, "sortedVisibleMediaItems", _descriptor14, this);
      _initializerDefineProperty(this, "allMediaItems", _descriptor15, this);
      _initializerDefineProperty(this, "mediaNotesSearchString", _descriptor16, this);
      _initializerDefineProperty(this, "mediaTypeFilter", _descriptor17, this);
      _initializerDefineProperty(this, "queryLabelIds", _descriptor18, this);
      _initializerDefineProperty(this, "querySocialProfileIds", _descriptor19, this);
      _initializerDefineProperty(this, "searchString", _descriptor20, this);
      _initializerDefineProperty(this, "selectedAssets", _descriptor21, this);
      _initializerDefineProperty(this, "setDateFilter", _descriptor22, this);
      _initializerDefineProperty(this, "showAdvancedActions", _descriptor23, this);
      _initializerDefineProperty(this, "showBulkLabelAdd", _descriptor24, this);
      _initializerDefineProperty(this, "showFilter", _descriptor25, this);
      _initializerDefineProperty(this, "showingTableView", _descriptor26, this);
      _initializerDefineProperty(this, "usedUnused", _descriptor27, this);
      _defineProperty(this, "mediaSortDefinition", ['createdAt:desc']);
      _defineProperty(this, "deleteMediaItems", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (mediaItems) {
          const mediaItemsLength = mediaItems.length;
          const didConfirm = yield this.dialogManager.confirmation(this.intl.t('media_library.delete_selected_media'), {
            description: this.intl.t('media_library.delete_n_media_confirm', {
              number: mediaItemsLength
            }),
            confirmButton: this.intl.t('shared_words.delete')
          });
          if (!didConfirm) {
            return;
          }
          _nprogress.default.start();
          //this needs to be a for-loop becauseof the 'yield' -iMack
          for (let i = 0; i < mediaItemsLength; i++) {
            const mediaItem = mediaItems[i] || {};
            this.removeStarred(mediaItem);
            try {
              yield (0, _deleteMediaItem.default)(mediaItem);
              if (this.currentGroup) {
                this.currentGroup.mediaItemCount -= 1;
              }
            } catch (error) {
              this.alerts.warning(error.message);
            } finally {
              _nprogress.default.set(i + 1.0 / (mediaItemsLength * 1.0));
            }
          }
          this.selectedAssets.clear();
          _nprogress.default.done();
        }
      }), null, "deleteMediaItems", "drop"));
      _defineProperty(this, "moveToGroup", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (currentGroup, newGroup) {
          const didConfirm = yield this.dialogManager.confirmation(this.intl.t('media_library.confirm_move_header'), {
            description: this.intl.t('media_library.confirm_move', {
              current_group: currentGroup.name,
              group_name: newGroup.name
            }),
            confirmButton: this.intl.t('shared_words.move')
          });
          if (!didConfirm) {
            return;
          }
          this.selectedAssets.forEach(mediaItem => {
            mediaItem.set('group', newGroup);
            mediaItem.save();
          });
          _classPrivateMethodGet(this, _removeMovedMediaItems, _removeMovedMediaItems2).call(this, this.selectedAssets);
          this.selectedAssets.clear();
          this.showAdvancedActions = false;
        }
      }), null, "moveToGroup", "drop"));
      this.mediaNotesSearchString = this.queryPersistence.getSearchString('media-library', '');
      this.mediaTypeFilter = this.queryPersistence.getMediaTypeFilter('media-library', '');
      this.queryLabelIds = this.queryPersistence.getLabelIds('media-library', '');
      this.querySocialProfileIds = this.queryPersistence.getSocialProfileIds('media-library', '');
      this.searchString = this.queryPersistence.getSearchString('media-library', '');
      this.selectedAssets = new _trackedBuiltIns.TrackedArray();
      this.setDateFilter = this.queryPersistence.getDateFilter('media-library', 'all');
      this.showAdvancedActions = false;
      this.showBulkLabelAdd = false;
      this.showFilter = true;
      this.showingTableView = false;
      this.usedUnused = this.queryPersistence.getUsedUnused('media-library', '');
    }
    get queryLoading() {
      return this.mediaItemQuery.isLoading(this.currentQueryListString);
    }
    get queryLoadingMore() {
      return this.mediaItemQuery.isLoadingMore(this.currentQueryListString);
    }
    get canLoadMore() {
      return !this.mediaItemQuery.isCompleted(this.currentQueryListString);
    }
    get visibleMediaItems() {
      return (0, _utils.isNone)(this.currentQueryListString) ? this.allMediaItems : this.mediaItemQuery.filterMediaItems(this.allMediaItems, this.queryListParams);
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
    get isSearchingLabels() {
      return !(0, _utils.isEmpty)(this.queryLabelIds);
    }
    get isBeingFiltered() {
      return this.isSearchingLabels || !((0, _utils.isEmpty)(this.usedUnused) && (0, _utils.isEmpty)(this.mediaTypeFilter)) || !(0, _utils.isEmpty)(this.querySocialProfileIds) || !(0, _utils.isEmpty)(this.mediaNotesSearchString) || this.setDateFilter !== 'all';
    }
    get hasMedia() {
      return this.visibleMediaItems.length > 0 || this.canLoadMore || this.queryLoadingMore;
    }
    get hasSearchTerms() {
      return !(0, _utils.isEmpty)(this.searchString) || !(0, _utils.isEmpty)(this.mediaNotesSearchString);
    }
    get otherAccountGroups() {
      return this.auth.groups.filter(group => group.id !== this.currentGroup?.id && group.contributor !== true);
    }
    get allVisibleMediaItemsSelected() {
      if (this.visibleMediaItems.length === 0) {
        return false;
      }
      return this.visibleMediaItems.every(mediaItem => this.selectedAssets.includes(mediaItem));
    }
    get currentQueryListArray() {
      return (0, _formatQuery.buildQueryArray)(this.queryLabelIds, this.setDateFilter, this.mediaNotesSearchString, this.usedUnused, this.mediaTypeFilter, this.querySocialProfileIds, this.currentGroup?.id);
    }
    get currentQueryListString() {
      return (0, _formatQuery.queryListToString)(this.currentQueryListArray);
    }
    get queryListParams() {
      return {
        groupId: this.currentGroup?.id,
        labelIds: this.queryLabelIds,
        searchString: this.mediaNotesSearchString,
        socialProfileIds: this.querySocialProfileIds,
        mediaTypeFilter: this.mediaTypeFilter,
        usedUnused: this.usedUnused,
        dateFilter: this.setDateFilter,
        limit: _constants.MEDIA_ITEMS_LIMIT
      };
    }
    get mediaItemCount() {
      return this.isBeingFiltered ? this.visibleMediaItems.length : this.currentGroup?.mediaItemCount;
    }
    get firstQueryLoad() {
      return this.queryLoading && !this.queryLoadingMore;
    }
    get queryLabels() {
      if ((0, _utils.isEmpty)(this.currentGroup?.labels) || (0, _utils.isEmpty)('queryLabelIds')) {
        return new _trackedBuiltIns.TrackedArray();
      }
      const queryLabels = this.currentGroup?.labels.filter(label => this.queryLabelIds.includes(parseInt(label.id)));
      return new _trackedBuiltIns.TrackedArray(queryLabels || []);
    }
    openAssetModal(mediaItem) {
      this.router.transitionTo('cluster.media.edit', mediaItem.id);
    }
    addNewLabel(label, labelList, createdFromLabelMedia) {
      this.mediaLabels.addNewLabel.perform(label, labelList, createdFromLabelMedia);
    }
    showTableView() {
      this.showingTableView = true;
      this.segment.track('viewed-table-view', {
        group_id: this.currentGroup?.id || null
      });
    }
    showGridView() {
      this.showingTableView = false;
    }
    toggleLabelAdd() {
      this.showBulkLabelAdd = !this.showBulkLabelAdd;
    }
    toggleAdvancedActions() {
      this.showAdvancedActions = !this.showAdvancedActions;
    }
    addSelection(mediaItem) {
      this.selectedAssets.addObject(mediaItem);
    }
    removeSelection(mediaItem) {
      this.selectedAssets.removeObject(mediaItem);
    }
    toggleSelectAll() {
      if (this.allVisibleMediaItemsSelected) {
        this.deselectAll();
      } else {
        this.selectAll();
      }
    }
    selectAll() {
      this.selectedAssets.addObjects(this.visibleMediaItems);
    }
    deselectAll() {
      this.selectedAssets.clear();
    }
    applyBulkLabels(newLabels) {
      this.selectedAssets.forEach(mediaItem => {
        if (!mediaItem) {
          return;
        }
        const uniqueLabels = newLabels.filter(label => !mediaItem.labels.includes(label));
        const labelNames = uniqueLabels.map(label => label.canonicalTagName).join(', ');
        this.segment.track('labelled-media', {
          image_url: mediaItem.imageUrl,
          video_url: mediaItem.videoUrl,
          label: labelNames,
          location: 'media library bulk'
        });
        uniqueLabels.forEach(label => label.increaseTaggedCount());
        mediaItem.labels.addObjects(uniqueLabels);
        mediaItem.save();
      });
      this.closeBulkLabelAdd();
      this.deselectAll();
      this.alerts.info(this.intl.t('alerts.media_items.labels.labels_added'));
    }
    closeBulkLabelAdd() {
      this.showBulkLabelAdd = false;
    }
    starMediaBulk() {
      this.starredMedia.starMediaBulk(this.selectedAssets);
      this.deselectAll();
    }
    searchMediaNotes() {
      this.mediaNotesSearchString = this.searchString;
      this.queryPersistence.setSearchString('media-library', this.searchString);
      _classPrivateMethodGet(this, _deselectAndFilter, _deselectAndFilter2).call(this);
    }
    addQueryLabel(labelId) {
      this.queryLabelIds.addObject(parseInt(labelId));
      this.queryPersistence.setLabelIds('media-library', this.queryLabelIds);
      _classPrivateMethodGet(this, _deselectAndFilter, _deselectAndFilter2).call(this);
    }
    removeQueryLabel(labelId) {
      this.queryLabelIds.removeObject(parseInt(labelId));
      this.queryPersistence.setLabelIds('media-library', this.queryLabelIds);
      _classPrivateMethodGet(this, _deselectAndFilter, _deselectAndFilter2).call(this);
    }
    updateDateFilter(_ref) {
      let {
        filter
      } = _ref;
      this.setDateFilter = filter;
      this.queryPersistence.setDateFilter('media-library', filter);
      _classPrivateMethodGet(this, _deselectAndFilter, _deselectAndFilter2).call(this);
    }
    clearQuerySocialProfile() {
      this.querySocialProfileIds.clear();
      this.queryPersistence.setSocialProfileIds('media-library', this.querySocialProfileIds);
      _classPrivateMethodGet(this, _deselectAndFilter, _deselectAndFilter2).call(this);
    }
    addQuerySocialProfile(_ref2) {
      let {
        id
      } = _ref2;
      const socialProfileId = parseInt(id);
      this.querySocialProfileIds.clear();
      this.querySocialProfileIds.addObject(socialProfileId);
      this.queryPersistence.setSocialProfileIds('media-library', this.querySocialProfileIds);
      _classPrivateMethodGet(this, _deselectAndFilter, _deselectAndFilter2).call(this);
    }
    removeQuerySocialProfile(_ref3) {
      let {
        id
      } = _ref3;
      const socialProfileId = parseInt(id);
      this.querySocialProfileIds.removeObject(socialProfileId);
      this.queryPersistence.setSocialProfileIds('media-library', this.querySocialProfileIds);
      _classPrivateMethodGet(this, _deselectAndFilter, _deselectAndFilter2).call(this);
    }
    setUsedUnused(_ref4) {
      let {
        value
      } = _ref4;
      this.usedUnused = value;
      this.queryPersistence.setUsedUnused('media-library', value);
      if (value === '') {
        this.querySocialProfileIds.clear();
        this.queryPersistence.setSocialProfileIds('media-library', this.querySocialProfileIds);
      }
      _classPrivateMethodGet(this, _deselectAndFilter, _deselectAndFilter2).call(this);
    }
    setMediaTypeFilter(_ref5) {
      let {
        value
      } = _ref5;
      this.mediaTypeFilter = value;
      this.queryPersistence.setMediaTypeFilter('media-library', value);
      _classPrivateMethodGet(this, _deselectAndFilter, _deselectAndFilter2).call(this);
    }
    clearMediaFilters() {
      _classPrivateMethodGet(this, _clearMediaFilters, _clearMediaFilters2).call(this);
      _classPrivateMethodGet(this, _filteredQuery, _filteredQuery2).call(this, {
        trackEvent: false
      });
    }
    clearAllFilters() {
      _classPrivateMethodGet(this, _clearMediaFilters, _clearMediaFilters2).call(this);
      _classPrivateMethodGet(this, _deselectAndFilter, _deselectAndFilter2).call(this);
    }
    loadMore() {
      _classPrivateMethodGet(this, _filteredQuery, _filteredQuery2).call(this, {
        loadMore: true
      });
    }
    clearMediaSearch() {
      this.mediaNotesSearchString = '';
      this.searchString = '';
      _classPrivateMethodGet(this, _deselectAndFilter, _deselectAndFilter2).call(this);
    }
    unstarAll() {
      this.starredMedia.unstarAll();
    }
    addStarred(mediaItem) {
      this.starredMedia.addStarred(mediaItem);
    }
    removeStarred(mediaItem) {
      this.starredMedia.removeStarred(mediaItem);
    }
    setMediaNavigationItems() {
      this.mediaNavigation.setMediaItems(this.visibleMediaItems);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "mediaItemQuery", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "mediaLabels", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "mediaNavigation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "queryPersistence", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "starredMedia", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "queryListQuery", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "queryListStartQuery", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "sortedVisibleMediaItems", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "allMediaItems", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "mediaNotesSearchString", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "mediaTypeFilter", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "queryLabelIds", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "querySocialProfileIds", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "searchString", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "selectedAssets", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "setDateFilter", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "showAdvancedActions", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "showBulkLabelAdd", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "showFilter", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "showingTableView", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "usedUnused", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "queryLoading", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "queryLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "queryLoadingMore", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "queryLoadingMore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canLoadMore", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "canLoadMore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "visibleMediaItems", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "visibleMediaItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openAssetModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openAssetModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addNewLabel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addNewLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTableView", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showTableView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showGridView", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showGridView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleLabelAdd", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleLabelAdd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleAdvancedActions", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAdvancedActions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addSelection", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeSelection", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSelectAll", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSelectAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectAll", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deselectAll", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "deselectAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applyBulkLabels", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "applyBulkLabels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeBulkLabelAdd", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeBulkLabelAdd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "starMediaBulk", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "starMediaBulk"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchMediaNotes", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "searchMediaNotes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addQueryLabel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addQueryLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeQueryLabel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeQueryLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateDateFilter", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateDateFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearQuerySocialProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearQuerySocialProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addQuerySocialProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addQuerySocialProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeQuerySocialProfile", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeQuerySocialProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUsedUnused", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setUsedUnused"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMediaTypeFilter", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setMediaTypeFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearMediaFilters", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearMediaFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearAllFilters", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearAllFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadMore", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadMore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearMediaSearch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearMediaSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unstarAll", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "unstarAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addStarred", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addStarred"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeStarred", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeStarred"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMediaNavigationItems", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setMediaNavigationItems"), _class.prototype)), _class));
  function _removeMovedMediaItems2(mediaItems) {
    _nprogress.default.start();
    mediaItems.forEach((mediaItem, index) => {
      this.removeStarred(mediaItem);
      try {
        if (this.currentGroup) {
          this.currentGroup.mediaItemCount -= 1;
        }
        this.set('allMediaItems', this.allMediaItems.filter(media => media.id !== mediaItem.id));
      } catch (error) {
        this.alerts.warning(error.message);
      } finally {
        _nprogress.default.set(index + 1.0 / (mediaItems.length * 1.0));
      }
    });
    _nprogress.default.done();
  }
  function _deselectAndFilter2() {
    this.deselectAll();
    _classPrivateMethodGet(this, _filteredQuery, _filteredQuery2).call(this);
  }
  function _clearMediaFilters2() {
    this.queryLabelIds.clear();
    this.setDateFilter = 'all';
    this.mediaNotesSearchString = '';
    this.searchString = '';
    this.usedUnused = '';
    this.mediaTypeFilter = '';
    this.querySocialProfileIds.clear();
    this.queryPersistence.clear('media-library');
  }
  function _filteredQuery2(opts) {
    const params = Object.assign({}, this.queryListParams);
    params.page = 'media-library';
    params.limit = _constants.MEDIA_ITEMS_LIMIT;
    if (opts) {
      if ('loadMore' in opts) {
        params.loadMore = opts.loadMore;
      }
      if ('trackEvent' in opts) {
        params.trackEvent = opts.trackEvent;
      }
    }
    this.mediaItemQuery.queryWithFilters(params);
  }
});